import React, { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { MediaItem, MorePhotos } from '@netbasequid/core'
// @ts-ignore
import { ref, sys } from '@netbasequid/theme'
import { AutomationId } from 'utils/automationUtil'
import { Theme } from '../../../features/ui/types'
import { useDisplayTheme } from '../../../hooks/useUiState'
import { StyledContainer, StyledPreviewNAWording, BackgroundColor } from './index.css'
import MediaCardContext, { MediaCardProps } from './mediaCardContext'
import Footer from './Footer'

const MEDIA_CARD_WIDTH = '160px'
const MEDIA_CARD_HEIGHT = '188px'
const MEDIA_ITEM_WIDTH = '160px'
const MEDIA_ITEM_HEIGHT = '160px'

const MediaCard = ({
  mediaType,
  mediaUrl,
  thumbnailUrl,
  domain,
  dataStream,
  engagements,
  footer,
  hasMultipleMedia,
  onClick
}: MediaCardProps) => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  const [isError, setIsError] = useState(false)
  const handleError = useCallback(() => {
    setIsError(true)
  }, [setIsError])

  const iconColor = useMemo(() => {
    if (theme === 'light' && isError) {
      return ref.color.gray[600]
    }
    return sys.dark.text.primary
  }, [isError, theme])

  return (
    <MediaCardContext.Provider
      value={{
        mediaType,
        mediaUrl,
        thumbnailUrl,
        domain,
        dataStream,
        engagements,
        footer,
        isError,
        mode: theme
      }}>
      {/* Underlying background color for presenting elevation style when hover and press. */}
      <BackgroundColor mode={theme} width={MEDIA_CARD_WIDTH} height={MEDIA_CARD_HEIGHT}>
        <StyledContainer
          onClick={onClick}
          data-testid={AutomationId.mediaCard.item}
          mode={theme}
          width={MEDIA_CARD_WIDTH}
          height={MEDIA_CARD_HEIGHT}>
          <MediaItem
            mode={theme}
            data={{
              mediaType,
              mediaUrl,
              thumbnailUrl
            }}
            width={MEDIA_ITEM_WIDTH}
            height={MEDIA_ITEM_HEIGHT}
            previewNaUrl="https://help.quid.com/articles/8240236#h_24b221c46b"
            previewNaUrlWording={
              <StyledPreviewNAWording mode={theme}>{t('moreThreeDot')}</StyledPreviewNAWording>
            }
            previewNaWording={
              <StyledPreviewNAWording mode={theme}>
                {t('previewUnavailable')}
              </StyledPreviewNAWording>
            }
            backgroundColor="transparent"
            topRightIcon={hasMultipleMedia ? <MorePhotos color={iconColor} /> : undefined}
            onError={handleError}
          />
          <Footer />
        </StyledContainer>
      </BackgroundColor>
    </MediaCardContext.Provider>
  )
}

export default MediaCard
